import { notify } from "react-notify-toast";

import { mainCategories } from "../components/static-data";
var currentBounceAnimation;
var currentBounceElement;
//private
const getTagsQuery = (selectedTags) => {
  const x = selectedTags
    .map((p) => {
      p = p.replace(/\"/g, "");
      return '"' + p + '"';
    })
    .join(",");
  return `&tags=[${x}]`;
};
const getServicesQuery = (selectedTags) => {
  const x = selectedTags
    .map((p) => {
      p = p.replace(/\"/g, "");
      return '"' + p + '"';
    })
    .join(",");
  return `&options=[${x}]`;
};

const parseQueryString = (query) => {
  if (query.indexOf("?") > -1) {
    query = query.replace(/\?/g, "&");
  }

  var vars = query.split("&");
  vars = vars.filter((f) => {
    return f && f.length > 0;
  });

  var queryString = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof queryString[key] === "undefined") {
      queryString[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof queryString[key] === "string") {
      var arr = [queryString[key], decodeURIComponent(value)];
      queryString[key] = arr;
      // If third or later entry with this name
    } else {
      queryString[key].push(decodeURIComponent(value));
    }
  }

  queryString.get = (param) => {
    if (queryString.hasOwnProperty(param)) {
      return queryString[param];
    }
  };

  return queryString;
};

const encodeQueryString = (data) => {
  const ret = [];
  for (let d in data) {
    if (typeof data[d] !== "function") {
      ret.push(
        encodeURIComponent(d) +
          "=" +
          encodeURIComponent(
            Array.isArray(data[d]) ? JSON.stringify(data[d]) : data[d],
          ),
      );
    }
  }
  return ret.join("&");
};

export const placeholderSrc = (width, height) =>
  `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`;

export const handleDropdownClose = (param) => {
  if (!window.location.search || window.location.search.indexOf(param) < 0)
    return;
  const obj = parseQueryString(window.location.search);
  delete obj[param];

  var tmpPath = "";
  //comment in to not change url when on landing page
  if (
    typeof window !== "undefined" &&
    window.location.href.indexOf("/search") < 0
  )
    tmpPath = window.location.pathname;
  else tmpPath = "/search/" + getCategory(window.location.href);

  const newUrl = encodeQueryString(obj);
  if (newUrl) tmpPath = tmpPath + "?" + newUrl;

  window.history.pushState({ id: "Dropdown Close" }, "Category", tmpPath);

  var left = document.querySelector(".pageContent .left");
  if (left) {
    left.classList.remove("scrollBlock");
  }
};

export const handleDropdownOpen = (param) => {
  let newUrl =
    window.location.href +
    `${formatQueryParams(window.location.href)}${param}=1`;

  window.history.pushState({ id: "Dropdown Open" }, param, newUrl);

  var left = document.querySelector(".pageContent .left");
  if (left) {
    left.classList.add("scrollBlock");
  }
};
const getFavouritedNode = () => {
  return (
    <div style={{ fontWeight: "500", color: "white" }}>
      Wir haben den Anbieter unter{" "}
      <a
        href="https://www.weddyplace.com/inbox/"
        style={{ color: "white", textDecoration: "underline" }}
      >
        Favoriten{" "}
      </a>
      gespeichert
    </div>
  );
};

const getFavStatus = (fav) => {
  if (fav) {
    return (
      fav.status === "Liked" ||
      fav.status === "Contact - pending" ||
      fav.status === "Contact - opened"
    );
  }
  return false;
};

export const getCategoryTitleWithKey = (key) => {
  let category = mainCategories.find((cat) => cat.key === key);
  if (category) return category.title;
  return "Locations";
};

//exported
export const getCookie = (name) => {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
};

export const setCookie = (name, value, days) => {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
};

const getCategory = (passedPath) => {
  let pathName = "";
  if (typeof window !== "undefined") pathName = passedPath;
  let cat = pathName.split("/");
  cat = cat[cat.length - 1];

  if (cat == "search") {
    cat = "locations";
  } else {
    cat = cat.split("?");
    cat = cat[0];
  }

  return cat;
};

export const scrollIntoView = (selectedVendor) => {
  if (currentBounceAnimation) {
    currentBounceAnimation.cancel();
  }
  if (currentBounceElement) {
    currentBounceElement.classList.remove('highlighted-tile')
  }
  const selectedVendorRef = document.querySelector(
    `[data-id='${selectedVendor.id}']`,
  );

  if (selectedVendorRef) {
    selectedVendorRef?.scrollIntoView({ behavior: "smooth", block: "center" });
    selectedVendorRef.classList.add('highlighted-tile');
    currentBounceElement = selectedVendorRef;

    currentBounceAnimation = selectedVendorRef?.animate(
      [
        {
          transform: "scale(0.98)",
          boxShadow: "0 0 0 0 rgba(0, 123, 144, 0.7)",
        },
        {
          transform: "scale(1.02)",
          boxShadow: "0 0 0 10px rgba(0, 123, 144, 0)",
        },
        {
          transform: "scale(1)",
        },
        {
          transform: "scale(1)",
        },
      ],
      {
        duration: 1500,
        iterations: 2,
      },
    );
  }
};

export const horizontalScrollIntoView = (selectedVendor) => {
  if (currentBounceAnimation) {
    currentBounceAnimation.cancel();
  }
  if (currentBounceElement) {
    currentBounceElement.classList.remove('highlighted-tile')
  }
  const selectedVendorRef = document.querySelector(
    `[data-id='${selectedVendor.id}']`,
  );

  const horizontalVendorsContainer = document.getElementById(
    "horizontalVendorsContainer",
  );

  if (selectedVendorRef) {
    horizontalVendorsContainer.scrollLeft = selectedVendorRef.offsetLeft - 32;
    selectedVendorRef.classList.add('highlighted-tile');
    currentBounceElement = selectedVendorRef;
    
    currentBounceAnimation = selectedVendorRef?.animate(
      [
        {
          transform: "scale(0.98)",
          boxShadow: "0 0 0 0 rgba(0, 123, 144, 0.7)",
        },
        {
          transform: "scale(1.02)",
          boxShadow: "0 0 0 10px rgba(0, 123, 144, 0)",
        },
        {
          transform: "scale(1)",
        },
        {
          transform: "scale(1)",
        },
      ],
      {
        duration: 1500,
        iterations: 2,
      },
    );
  }
};

export const getFiltersFromURLParams = () => {
  let initialSearch = "";
  var initialCategory = "locations";

  //if not search inside url
  //seo_meta is placing a search url inside metadata, use that to init params....
  if (
    typeof window !== "undefined" &&
    window.location.href.indexOf("/search") < 0
  ) {
    var tmp = document.querySelector('meta[name="search_url"]');
    if (tmp) {
      initialSearch = tmp.content;
      if (initialSearch) {
        initialCategory = getCategory(initialSearch);
        var tmpArr = initialSearch.split("?");
        if (tmpArr) initialSearch = tmpArr[1];
      }
    }
  } else if (typeof window !== "undefined") {
    initialSearch = window.location.search;
    initialCategory = getCategory(window.location.href);
  }

  const searchParams = parseQueryString(initialSearch);
  let initialTags = [];
  let initialServices = [];

  const initialCity = searchParams.get("loc");
  const initialCapacity = searchParams.get("capacityEnd");
  const initialBudget = searchParams.get("budgetEnd");
  const initialLat = searchParams.get("lat");
  const initialLng = searchParams.get("lng");
  const initialZoom = searchParams.get("zoom");
  
  const tagsQuery = searchParams.get("tags");
  if (tagsQuery) {
    initialTags = tagsQuery.replace(/\[|\]/g, "").split(",");
  }
  const servicesQuery = searchParams.get("services");
  if (servicesQuery) {
    initialServices = servicesQuery.replace(/\[|\]/g, "").split(",");
  }

  return {
    initialCategory,
    initialCity,
    initialCapacity,
    initialBudget,
    initialLat,
    initialLng,
    initialZoom,
    initialTags,
    initialServices
  };
};

//ensuring that there are no multiple ?s
export const formatQueryParams = (urlAfter) => {
  if (urlAfter.indexOf("?") < 0) return "?";
  return "&";
};

export const getURL = (isForBrowser, allFilters) => {
  const { cityFilter, lat, lng, zoom, budgetFilter, capacityFilter, selectedTags, selectedServices } =
    allFilters;

  let urlAfter = "";

  if (cityFilter) urlAfter += `${formatQueryParams(urlAfter)}loc=${cityFilter}`;

  if (lat) urlAfter += `${formatQueryParams(urlAfter)}lat=${lat}`;
  if (lng) urlAfter += `${formatQueryParams(urlAfter)}lng=${lng}`;
  if (zoom) urlAfter += `${formatQueryParams(urlAfter)}zoom=${zoom}`;

  if (budgetFilter)
    urlAfter += `${formatQueryParams(urlAfter)}budgetEnd=${budgetFilter}`;

  if (capacityFilter) {
    if (isForBrowser) {
      urlAfter += `${formatQueryParams(urlAfter)}capacityEnd=${capacityFilter}`;
    } else {
      urlAfter += `${formatQueryParams(
        urlAfter,
      )}services=[{"key":"loc_guests","value":${capacityFilter}}]`;
    }
  }

  if (selectedTags && selectedTags.length !== 0) {
    if (isForBrowser) {
      urlAfter += `${formatQueryParams(urlAfter)}tags=[${selectedTags.join(
        ",",
      )}]`;
    } else {
      urlAfter += getTagsQuery(selectedTags);
    }
  }
  if (selectedServices && selectedServices.length !== 0) {
    if (isForBrowser) {
      urlAfter += `${formatQueryParams(urlAfter)}options=[${selectedServices.join(
        ",",
      )}]`;
    } else {
      urlAfter += getServicesQuery(selectedServices);
    }
  }

  return urlAfter;
};

export const parseVendorsData = (data) => {
  let vendorsData = [];
  let interestingVendors = [];
  if (data && data.results) {
    data.results.forEach((arrayItem) => {
      arrayItem.vendors.forEach((vendor) => {
        let parsedData = {
          id: String(vendor._id),
          // title: String(vendor.weddyplace_name || vendor.name),
          title: String(vendor.name),
          description: String(vendor.description),
          headerImgSrc: String(vendor.headerImgSrc),
          gallery: vendor.gallery,
          city: String(vendor.city),
          category: String(vendor.category),
          slug: String(vendor.slug),
          numberLikes: vendor.numberLikes,
          numberReviews: vendor.numberReviews,
          tagging: vendor.tagging,
          location: vendor.location,
          maxGuests: vendor.maxGuests,
          pricePerson: vendor.pricePerson,
          pricePersonConfirmed: vendor.pricePersonConfirmed,
          priceRangeStart: vendor.priceRangeStart,
          priceRangeEnd: vendor.priceRangeEnd,
          isVip: vendor.isVip,
          isTop: vendor.isTop,
          isFast: vendor.isFast,
          rating: String(vendor.rating),
          favourited: getFavStatus(vendor.fav),
          distance: vendor.distance,
        };
        vendorsData.push(parsedData);
      });
    });
  }

  if (vendorsData.length < 5) {
    if (data && data.interesting) {
      data.interesting.forEach((vendor) => {
        let parsedData = {
          id: String(vendor._id),
          title: String(vendor.weddyplace_name || vendor.name),
          description: String(vendor.description),
          headerImgSrc: String(vendor.headerImgSrc),
          gallery: vendor.gallery,
          city: String(vendor.city),
          category: String(vendor.category),
          slug: String(vendor.slug),
          numberLikes: vendor.numberLikes,
          numberReviews: vendor.numberReviews,
          tagging: vendor.tagging,
          location: vendor.location,
          maxGuests: vendor.maxGuests,
          pricePerson: vendor.pricePerson,
          pricePersonConfirmed: vendor.pricePersonConfirmed,
          priceRangeStart: vendor.priceRangeStart,
          priceRangeEnd: vendor.priceRangeEnd,
          isVip: vendor.isVip,
          isTop: vendor.isTop,
          isFast: vendor.isFast,
          rating: String(vendor.rating),
          favourited: getFavStatus(vendor.fav),
          distance: vendor.distance,
        };
        interestingVendors.push(parsedData);
      });
    }
  }

  return { vendorsData, interestingVendors };
};

export const getVendorCost = (vendor) => {
  // if there's a pricePerson, use pricePerson, else use priceRangeStart
  return vendor.pricePerson || vendor.priceRangeStart;
};

export const getVendorCostCategory = (vendor) => {
  let costCategory;
  if (vendor.priceRangeEnd == 5000 || !vendor.priceRangeEnd)  {
    costCategory = 1;
  } else if (vendor.priceRangeEnd == 8000) {
    costCategory = 2;
  } else if (vendor.priceRangeEnd == 12000) {
    costCategory = 3;
  } else if (vendor.priceRangeEnd == 999999) {
    costCategory = 4;
  } else {
    costCategory = 1;
  }
  return costCategory;
};

export const conditionalToken = (token) => {
  if (!token) return "";
  return "Bearer " + JSON.parse(token);
};

export const showFavouriteSuccess = () => {
  let successTheme = { background: "#007b90", text: "#FFFFFF" };
  notify.show(getFavouritedNode(), "custom", 10000, successTheme);
};

export const showFavouriteFailure = () => {
  let failureTheme = { background: "#ED4337", text: "#FFFFFF" };
  notify.show(
    "Leider ist etwas schief gelaufen. Bitte probiere es zu einem späteren Zeitpunkt nochmal",
    "custom",
    5000,
    failureTheme,
  );
};
